import { LinkTo } from 'shared/constants/linkTo';

const underBooks = (path: string) => `/books${path}`;

export const EDITOR_ROUTES = [
    LinkTo.projectCreate,
    LinkTo.projectEdit,
    underBooks(LinkTo.projectEdit),
    LinkTo.presentationTemplates,
    LinkTo.teamEdit,
    LinkTo.teamCreate,
    LinkTo.teamCreateConstructor,
    LinkTo.teamCreateConstructorEdit,
    LinkTo.teamExternalEdit,
    LinkTo.teamExternalCreate,
    LinkTo.moduleEdit,
    LinkTo.themeEdit,
    LinkTo.courseCreate,
    LinkTo.courseEdit,
    LinkTo.courseModuleEdit,
    LinkTo.courseModuleThemeEdit,
    LinkTo.courseStudents,
    LinkTo.courseAnalytics,
    LinkTo.courseGroupEdit,
    LinkTo.competitionCreate,
    LinkTo.competitionEdit,
    LinkTo.competitionAutomaticCreate,
    LinkTo.competitionBriefCreate,
    LinkTo.seasonCreate,
    LinkTo.seasonEdit,
    LinkTo.bookCreate,
    LinkTo.bookEdit,
    underBooks(LinkTo.bookCreate),
    underBooks(LinkTo.bookEdit),
    LinkTo.bookProjectCreate,
    underBooks(LinkTo.bookProjectCreate),
    LinkTo.bookCreateMain,
    LinkTo.playbookCreate,
];

export const PROFILE_EDIT_ROUTES = [
    LinkTo.profileEdit,
    LinkTo.designerEdit,
];

export const PREVIEW_ROUTES = [
    LinkTo.preview,
    underBooks(LinkTo.preview),
    LinkTo.bookPreview,
    underBooks(LinkTo.bookPreview),
    LinkTo.previewTeam,
    LinkTo.previewTeamLongread,
    LinkTo.previewTeamLongreadExternal,
    LinkTo.previewExternalTeam,
    LinkTo.coursePreview
];
import { LinkTo } from 'shared/constants/linkTo';

const underBooks = (path: string) => `/books${path}`;

export const EDITOR_ROUTES = [
    LinkTo.projectCreate,
    LinkTo.projectEdit,
    underBooks(LinkTo.projectEdit),
    LinkTo.presentationTemplates,
    LinkTo.teamEdit,
    LinkTo.teamCreate,
    LinkTo.teamCreateConstructor,
    LinkTo.teamCreateConstructorEdit,
    LinkTo.teamExternalEdit,
    LinkTo.teamExternalCreate,
    LinkTo.moduleEdit,
    LinkTo.themeEdit,
    LinkTo.courseCreate,
    LinkTo.courseEdit,
    LinkTo.courseModuleEdit,
    LinkTo.courseModuleThemeEdit,
    LinkTo.courseStudents,
    LinkTo.courseAnalytics,
    LinkTo.courseGroupEdit,
    LinkTo.competitionCreate,
    LinkTo.competitionEdit,
    LinkTo.competitionAutomaticCreate,
    LinkTo.competitionBriefCreate,
    LinkTo.seasonCreate,
    LinkTo.seasonEdit,
    LinkTo.bookCreate,
    LinkTo.bookEdit,
    underBooks(LinkTo.bookCreate),
    underBooks(LinkTo.bookEdit),
    LinkTo.bookProjectCreate,
    underBooks(LinkTo.bookProjectCreate),
    LinkTo.bookCreateMain,
    LinkTo.playbookCreate,
];

export const PROFILE_EDIT_ROUTES = [
    LinkTo.profileEdit,
    LinkTo.designerEdit,
];

export const PREVIEW_ROUTES = [
    LinkTo.preview,
    underBooks(LinkTo.preview),
    LinkTo.bookPreview,
    underBooks(LinkTo.bookPreview),
    LinkTo.previewTeam,
    LinkTo.previewTeamLongread,
    LinkTo.previewTeamLongreadExternal,
    LinkTo.previewExternalTeam,
    LinkTo.coursePreview
];
